import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstName',
    standalone: false
})
export class FirstNamePipe implements PipeTransform {
  transform(value: string): any {
    return value.split(' ')[0];
  }
}
